import React from 'react';
import wood from './images/wood-background.jpg';

const SiteBackground: React.FC = () => {
  return (
    <div className="site-bg" aria-hidden>
      <img src={wood} alt="" />
    </div>
  );
};

export default SiteBackground;
